// extracted by mini-css-extract-plugin
module.exports = {"width":"styles_width__1h8IA","preview":"styles_preview__2bRSw","title":"styles_title__3vHn-","container":"styles_container__26IxI"};